<div
  class="card"
  [class.fab-variant]="fabVariant"
  *ngIf="data?.promotionProducts?.length || contained"
  [style.--text-color]="textColor"
  [style.--color]="brandColor">
  <div class="content-wrapper" *ngIf="!fabVariant">
    <div class="text-wrapper">
      <div class="title">{{ data.sectionTitle || 'Other products you might like' }}</div>
    </div>
  </div>
  <ng-container
    *ngIf="data?.galleryType === PromotionProductsData.GalleryTypeEnum.Carousel && data?.promotionProducts?.length">
    <p-carousel
      [value]="isEmptyState ? emptyData : data.promotionProducts!"
      [numVisible]="isMobileMode || contained ? 2.5 : 3.2"
      [numScroll]="1"
      [showNavigators]="false"
      [contentClass]="
        fabVariant ? 'promotion-products-fab ' : '' + (data.promotionProducts?.length! > 2 ? 'pod' : 'pod two-items')
      ">
      <ng-template let-product pTemplate="item">
        <div
          class="product-template"
          [ngStyle]="{ pointerEvents: isEmptyState || !product.link ? 'none' : '' }"
          trackable="{{ contained ? 'Settings/' : '' }}Tracking page/product{{ product.link }}">
          <a class="carousel-image-container" [href]="product.link" target="_blank">
            <ng-container *ngIf="product.imageUrl; else imagePlaceHolder">
              <div *ngIf="!isUrlLoaded(product.imageUrl)" class="img-loader"></div>
              <img
                ngSrc="{{ product.imageUrl }}"
                (load)="setUrlLoaded(product.imageUrl)"
                (error)="handleMissingImage($event, product.imageUrl)"
                alt=""
                [width]="fabVariant ? 90 : 110"
                [height]="fabVariant ? 90 : 110" />
            </ng-container>
          </a>

          <a class="product-title" [href]="product.link" target="_blank">{{ product.title || 'Product name' }}</a>
          <div class="product-prices" *ngIf="product.priceCents && discountPercent">
            <div class="discount-price">
              £{{ ((product.priceCents * (1 - discountPercent / 100)) / 100).toFixed(2) }}
            </div>
            <div class="original-price">£{{ (product.priceCents / 100).toFixed(2) }}</div>
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </ng-container>
  <ng-container
    *ngIf="data.galleryType === PromotionProductsData.GalleryTypeEnum.Tiles && data.promotionProducts?.length">
    <div class="tiles-container" [ngStyle]="{ pointerEvents: isEmptyState ? 'none' : '' }">
      <div
        *ngFor="let item of data.promotionProducts; last as last"
        [class.last]="last"
        [class.odd]="(data.promotionProducts!.length || 0) % 2 !== 0">
        <div
          class="product-template"
          trackable="{{ contained ? 'Settings/' : '' }}Tracking page/product{{ item.link }}"
          [ngStyle]="{ pointerEvents: isEmptyState || !item.link ? 'none' : '' }">
          <a class="image" [href]="item.link" target="_blank">
            <ng-container *ngIf="item.imageUrl; else imagePlaceHolder">
              <div *ngIf="!isUrlLoaded(item!.imageUrl!)" class="img-loader"></div>
              <img
                ngSrc="{{ item.imageUrl }}"
                (load)="setUrlLoaded(item.imageUrl!)"
                (error)="handleMissingImage($event, item.imageUrl!)"
                alt=""
                width="110"
                height="110" />
            </ng-container>
          </a>
          <a class="product-title" [href]="item.link" target="_blank">{{ item.title || 'Product name' }}</a>
          <div class="product-prices" *ngIf="item.priceCents && discountPercent">
            <div class="discount-price">£{{ ((item.priceCents * (1 - discountPercent / 100)) / 100).toFixed(2) }}</div>
            <div class="original-price">£{{ (item.priceCents / 100).toFixed(2) }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <a
    class="promotion-button"
    [ngStyle]="{ pointerEvents: !data.promotionButton?.link ? 'none' : '' }"
    trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ orderStatus }}/Products promotion button"
    [href]="data.promotionButton?.link"
    target="_blank"
    >{{ data.promotionButton?.text || 'Visit our shop' }}</a
  >
</div>

<ng-template #imagePlaceHolder>
  <div *ngIf="!data.isManualSet && data.storeCollectionUrl" class="img-loader image-placeholder"></div>
  <div *ngIf="data.isManualSet || !data.storeCollectionUrl" class="image-placeholder">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="image">
        <mask
          id="mask0_6718_10036"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40">
          <rect id="Bounding box" width="40" height="40" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6718_10036)">
          <path
            id="image_2"
            d="M7.77775 35C7.02775 35 6.37729 34.7245 5.82637 34.1736C5.27546 33.6227 5 32.9722 5 32.2222V7.77775C5 7.02775 5.27546 6.37729 5.82637 5.82638C6.37729 5.27546 7.02775 5 7.77775 5H32.2222C32.9722 5 33.6227 5.27546 34.1736 5.82638C34.7245 6.37729 35 7.02775 35 7.77775V32.2222C35 32.9722 34.7245 33.6227 34.1736 34.1736C33.6227 34.7245 32.9722 35 32.2222 35H7.77775ZM7.77775 32.2222H32.2222V7.77775H7.77775V32.2222ZM9.88888 28.4167H30.1389L23.9722 20.1945L18.6389 27.1667L14.8055 21.9723L9.88888 28.4167Z"
            fill="#BBC6D6" />
        </g>
      </g>
    </svg>
  </div>
</ng-template>
